import React from 'react';
import { FaCircleUp } from "react-icons/fa6";

const ScrollToTop = () => {

  window.addEventListener('scroll',()=>{
    const { scrollY } = window
    const scroll = document.querySelector('.ScrollToTop_m17')
    if(scroll){
      if(scrollY > 300){
        scroll.style.display = 'block'
      }else {
        scroll.style.display = 'none'
      }
    }
  })

  return (
    <div className='ScrollToTop_m17' onClick={()=> window.scrollTo({top: 0 , behavior : 'smooth'})}>
      <FaCircleUp size={35} color='#ff6600'/>
    </div>
  );
}

export default ScrollToTop;
